import { createFileRoute, notFound } from "@tanstack/react-router";
import ProductCategoryLanding from "@/pages/ProductCategoryLanding";
import { productCategories } from "@/lib/productCategoryConfig";
import { productCategoryArticlesQueryOptions, productCategoryTopListsQueryOptions } from "@/lib/productCategoryQuery";
import NotFound from "@/pages/NotFound";

export const Route = createFileRoute("/products/$categorySlug")({
  beforeLoad: ({ params }) => {
    if (!productCategories[params.categorySlug]) throw notFound();
  },
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(productCategoryArticlesQueryOptions(params.categorySlug)),
      context.queryClient.ensureQueryData(productCategoryTopListsQueryOptions(params.categorySlug)),
    ]);
  },
  head: ({ params }) => {
    const config = productCategories[params.categorySlug];
    if (!config) return {};
    const canonical = `https://www.garden-review.co.uk/products/${config.slug}`;
    return {
      meta: [
        { title: config.metaTitle },
        { name: "description", content: config.metaDescription },
        { property: "og:title", content: config.metaTitle },
        { property: "og:description", content: config.metaDescription },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_GB" },
        { property: "og:url", content: canonical },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: config.metaTitle },
        { name: "twitter:description", content: config.metaDescription },
      ],
      links: [{ rel: "canonical", href: canonical }],
    };
  },
  errorComponent: () => <div role="alert" className="container mx-auto px-4 py-16">Unable to load reviews. Please try again shortly.</div>,
  notFoundComponent: NotFound,
  component: ProductCategoryLanding,
});
